/**
 * Which dataset the type page is picking cases for, and the way back to it. Its cases come from one
 * scenario type, so on any other the banner points there instead.
 */

import { Link } from 'react-router';
import { Database } from 'lucide-react';
import { datasetUrl, pickCasesUrl } from '@/constants/paths';
import type { CasePicker } from './use-case-picker';

const LINK = 'shrink-0 font-medium text-indigo-700 hover:underline';

export const PickingBanner = ({ picker, onItsType }: { picker: CasePicker; onItsType: boolean }) => {
	const { dataset } = picker;
	return (
		<div
			role='status'
			className='flex shrink-0 items-center gap-2 rounded-md border border-indigo-200 bg-indigo-50/60 px-3 py-2 text-xs leading-4 text-indigo-900'
		>
			<Database className='size-3.5 shrink-0' aria-hidden />
			<p className='min-w-0 flex-1 truncate'>
				Adding cases to <span className='font-medium'>{dataset.name}</span>
				{!onItsType && `, from ${dataset.scenarioType?.description ?? 'its own scenario type'}`}
			</p>
			{!onItsType && (
				<Link to={pickCasesUrl(dataset.sopId, dataset.scenarioTypeId, dataset.id)} className={LINK}>
					Open its scenario type
				</Link>
			)}
			<Link to={datasetUrl(dataset.id)} className={LINK}>
				Back to the dataset
			</Link>
		</div>
	);
};
